import Container from '@zenbusiness/zui/Container';
import { styled } from '@zenbusiness/zui/styles';

export const PaymentContainerStyled = styled(Container)(() => ({
  // Override the root style
  padding: '0 !important'
}));
